"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const react_1 = require("react");
const utils_1 = require("../client/utils");
const utils_2 = require("./utils");
const useFragmentTypePolicyFieldName_1 = require("./useFragmentTypePolicyFieldName");
const useGetQueryDataByFieldName_1 = require("./useGetQueryDataByFieldName");
const client_2 = require("@apollo/client");
const equality_1 = require("@wry/equality");
// A hook for subscribing to a fragment for entities in the Apollo cache matching a given filter from a React component.
function useFragmentWhere(fragment, options) {
    var _a;
    const filter = options === null || options === void 0 ? void 0 : options.filter;
    const filterVarRef = (0, react_1.useRef)((0, client_2.makeVar)(filter));
    const filterVar = filterVarRef.current;
    const limit = options === null || options === void 0 ? void 0 : options.limit;
    const limitVarRef = (0, react_1.useRef)((0, client_2.makeVar)(limit));
    const limitVar = limitVarRef.current;
    const orderBy = options === null || options === void 0 ? void 0 : options.orderBy;
    const orderByVarRef = (0, react_1.useRef)((0, client_2.makeVar)(orderBy));
    const orderByVar = orderByVarRef.current;
    const context = (0, react_1.useContext)((0, client_1.getApolloContext)());
    const client = context.client;
    const cache = client === null || client === void 0 ? void 0 : client.cache;
    const fieldName = (0, useFragmentTypePolicyFieldName_1.useFragmentTypePolicyFieldName)();
    const emptyValue = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        if (typeof filter === 'function' && filter !== filterVar() || !(0, equality_1.equal)(filter, filterVar())) {
            filterVar(filter);
        }
    }, [filter]);
    (0, react_1.useEffect)(() => {
        if (limit !== limitVar()) {
            limitVar(limit);
        }
    }, [limit]);
    (0, react_1.useEffect)(() => {
        if (typeof orderBy === 'function' && orderBy !== orderByVar() || !(0, equality_1.equal)(orderBy, orderByVar())) {
            orderByVar(orderBy);
        }
    }, [orderBy]);
    const query = (0, utils_2.useOnce)(() => (0, utils_1.buildWatchFragmentWhereQuery)({
        filter,
        filterVar,
        limitVar,
        orderByVar,
        fragment,
        fieldName,
        cache,
        policies: cache.policies,
    }));
    const result = (0, useGetQueryDataByFieldName_1.useGetQueryDataByFieldName)(query, fieldName, options);
    return Object.assign(Object.assign({}, result), { data: (_a = result.data) !== null && _a !== void 0 ? _a : emptyValue.current });
}
exports.default = useFragmentWhere;
//# sourceMappingURL=useFragmentWhere.js.map